import MyStorePage from './MyStorePage';
export default MyStorePage;
